import React from 'react';
import { Box } from '@fiverr-private/theme';
import { ResponsiveTextAlignType } from '@fiverr-private/theme/src/components/Box/types';
import { richText } from './styles.ve.css';

interface RichTextProps {
    html: string;
    textAlign?: ResponsiveTextAlignType;
}

export const RichText = ({ html, textAlign = 'start' }: RichTextProps) => (
    <Box
        className={richText}
        textAlign={textAlign}
        color="black"
        fontWeight="light"
        fontSize="b_lg"
        letterSpacing="-0.72px"
        dangerouslySetInnerHTML={{ __html: html }}
    />
);
